/* Vivered: krepselio korekcijos - akciju korteliu (cross-sells) perkelimas po
   "Atsiskaitymas" mygtuko TIK TELEFONE (<=767px). Desktop'e kortelės lieka
   savo standartinėje vietoje - siauroje šoninėje juostoje netelpa gerai. 2026-09-22 */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var placeholder = null;

  function ensurePlaceholder(crossSells) {
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.style.display = 'none';
      placeholder.setAttribute('data-vivered-placeholder', 'true');
      crossSells.parentNode.insertBefore(placeholder, crossSells);
    }
  }

  function apply() {
    var crossSells = document.querySelector('.cross-sells');
    var footer = document.querySelector('.cart__footer');
    if (!crossSells || !footer) return;
    ensurePlaceholder(crossSells);

    if (mq.matches) {
      if (crossSells.parentElement !== footer) {
        crossSells.setAttribute('data-vivered-moved', 'true');
        footer.appendChild(crossSells);
      }
    } else if (placeholder && crossSells.parentElement !== placeholder.parentElement) {
      crossSells.removeAttribute('data-vivered-moved');
      placeholder.parentNode.insertBefore(crossSells, placeholder.nextSibling);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  document.addEventListener('cart:updated', apply);
  document.addEventListener('cart:refresh', apply);
  if (mq.addEventListener) {
    mq.addEventListener('change', apply);
  } else if (mq.addListener) {
    mq.addListener(apply);
  }
})();

/* Vivered: krepselio puslapis - prilipusi "Atsiskaitymas" juosta telefone,
   PAKEISTA 2026-09-22 kad veiktu LYGIAI TAIP PAT kaip MiMic "Į krepšelį" sticky
   juosta (zr. sia faila zemiau) - t.y. sukuriama atskira plaukiojanti juosta,
   kuri rodoma TIK kai vartotojas nuslenka zemiau tikrojo "Atsiskaitymas"
   mygtuko (jis pradingsta is ekrano virsuje), o ne visa laika. Paspaudus,
   tiesiog "paspaudziamas" tikrasis mygtukas, taigi visa esama krepselio/
   checkout logika islieka nepakeista, nieko nedubliuojant. */
(function () {
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var bar = null;
  var observer = null;

  function isCartPage() {
    return location.pathname === '/cart' || location.pathname.indexOf('/cart') === 0;
  }

  function formatTotalText() {
    var subtotal = document.querySelector('.cart__footer-subtotal');
    if (!subtotal) return '';
    var text = subtotal.textContent || '';
    var match = text.match(/€\s?\d[\d.,]*/);
    return match ? match[0].replace(/\s+/g, '') : '';
  }

  function buildBar() {
    var el = document.createElement('div');
    el.className = 'vivered-sticky-checkout';
    el.setAttribute('data-vivered-sticky-checkout', 'true');

    var info = document.createElement('div');
    info.className = 'vivered-sticky-checkout__info';

    var titleEl = document.createElement('span');
    titleEl.className = 'vivered-sticky-checkout__title';
    titleEl.textContent = 'Krepšelio suma';

    var priceEl = document.createElement('span');
    priceEl.className = 'vivered-sticky-checkout__price';
    priceEl.textContent = formatTotalText();

    info.appendChild(titleEl);
    info.appendChild(priceEl);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vivered-sticky-checkout__btn';
    btn.textContent = 'Atsiskaityti';
    btn.addEventListener('click', function () {
      var currentRealBtn = document.querySelector('.cart__submit');
      if (currentRealBtn) {
        currentRealBtn.click();
      }
    });

    el.appendChild(info);
    el.appendChild(btn);
    document.body.appendChild(el);
    return el;
  }

  function refreshTotal() {
    if (!bar) return;
    var priceEl = bar.querySelector('.vivered-sticky-checkout__price');
    if (priceEl) priceEl.textContent = formatTotalText();
  }

  function init() {
    if (!isCartPage() || !mqMobile.matches) return;
    var realBtn = document.querySelector('.cart__submit');
    if (!realBtn || bar) return;

    bar = buildBar();

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        var backToTop = document.querySelector('.back-to-top');
        if (backToTop) {
          backToTop.classList.toggle('vivered-above-sticky-atc', scrolledPast);
        }
      });
    }, { threshold: 0 });
    observer.observe(realBtn);

    document.addEventListener('cart:updated', refreshTotal);
    document.addEventListener('cart:refresh', refreshTotal);
  }

  function teardown() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (bar) {
      bar.parentNode.removeChild(bar);
      bar = null;
    }
    var backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
      backToTop.classList.remove('vivered-above-sticky-atc');
    }
  }

  function apply() {
    if (isCartPage() && mqMobile.matches) {
      init();
    } else {
      teardown();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  if (mqMobile.addEventListener) {
    mqMobile.addEventListener('change', apply);
  } else if (mqMobile.addListener) {
    mqMobile.addListener(apply);
  }
  document.addEventListener('cart:updated', apply);
  document.addEventListener('cart:refresh', apply);
})();

/* Vivered: MiMic produkto puslapis - "100% saugus mokejimai" zenkliuko perkelimas
   arciau pirkimo mygtuko (CTA), kad sustiprintu pasitikejima sprendimo momentu.
   Anksciau sis blokas buvo kairiajame turinio stulpelyje, atskirtas nuo CTA.
   Veikia atskirai desktop / mobile versijoms, nes tema turi du atskirus DOM
   mazgus (vienas "for-desktop", kitas "for-mobile"). Kiekvienas grazinamas i
   pradine vieta, jei ekranas perjungiamas per breakpoint'a (placeholder metodas,
   toks pat kaip cross-sells aukstai). 2026-09-22 */
(function () {
  var mqDesktop = window.matchMedia('(min-width: 768px)');
  var mqMobile = window.matchMedia('(max-width: 767px)');

  var desktopPlaceholder = null;
  var mobilePlaceholder = null;

  function ensurePlaceholder(el, storeFn, getFn) {
    if (!getFn()) {
      var ph = document.createElement('div');
      ph.style.display = 'none';
      ph.setAttribute('data-vivered-placeholder', 'true');
      el.parentNode.insertBefore(ph, el);
      storeFn(ph);
    }
  }

  function applyDesktop() {
    var trust = document.querySelector('.product__primary-left .payments-and-trust');
    var productForm = document.querySelector('.product__meta-content .product-form');
    if (!trust || !productForm) return;
    ensurePlaceholder(trust, function (ph) { desktopPlaceholder = ph; }, function () { return desktopPlaceholder; });

    if (mqDesktop.matches) {
      if (trust.parentElement !== productForm.parentElement || trust.previousElementSibling !== productForm) {
        trust.setAttribute('data-vivered-moved-desktop', 'true');
        productForm.parentNode.insertBefore(trust, productForm.nextSibling);
      }
    } else if (desktopPlaceholder && trust.parentElement !== desktopPlaceholder.parentElement) {
      trust.removeAttribute('data-vivered-moved-desktop');
      desktopPlaceholder.parentNode.insertBefore(trust, desktopPlaceholder.nextSibling);
    }
  }

  function applyMobile() {
    var trust = document.querySelector('.product__bottom .payments-and-trust');
    var mobileBlocks = document.querySelector('.product__bottom > .left-side-blocks.for-mobile > .product-blocks');
    if (!trust || !mobileBlocks) return;
    ensurePlaceholder(trust, function (ph) { mobilePlaceholder = ph; }, function () { return mobilePlaceholder; });

    if (mqMobile.matches) {
      if (mobileBlocks.firstElementChild !== trust) {
        trust.setAttribute('data-vivered-moved-mobile', 'true');
        mobileBlocks.insertBefore(trust, mobileBlocks.firstElementChild);
      }
    } else if (mobilePlaceholder && trust.parentElement !== mobilePlaceholder.parentElement) {
      trust.removeAttribute('data-vivered-moved-mobile');
      mobilePlaceholder.parentNode.insertBefore(trust, mobilePlaceholder.nextSibling);
    }
  }

  function apply() {
    applyDesktop();
    applyMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  if (mqDesktop.addEventListener) {
    mqDesktop.addEventListener('change', apply);
    mqMobile.addEventListener('change', apply);
  } else if (mqDesktop.addListener) {
    mqDesktop.addListener(apply);
    mqMobile.addListener(apply);
  }
})();

/* Vivered: MiMic produkto puslapis - prilipes "Į krepšelį" mygtukas telefone.
   Rodomas, kai tikrasis pirkimo mygtukas nusleñka virs ekrano viršaus (t.y.
   vartotojas jau praslinko zemiau). Paspaudus, tiesiog "paspaudziamas" tikrasis
   mygtukas - taip islaikoma visa esama pridejimo i krepseli logika (varianto
   patikra, AJAX krepselis, klaidu pranesimai ir t.t.), nieko nedubliuojant. 2026-09-22 */
(function () {
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var bar = null;
  var observer = null;

  function formatPriceText() {
    var priceBlock = document.querySelector('.product__price-block');
    if (!priceBlock) return '';
    var text = priceBlock.textContent || '';
    var match = text.match(/€\s?\d[\d.,]*/);
    return match ? match[0].replace(/\s+/g, '') : '';
  }

  function buildBar(realBtn) {
    var el = document.createElement('div');
    el.className = 'vivered-sticky-atc';
    el.setAttribute('data-vivered-sticky-atc', 'true');

    var info = document.createElement('div');
    info.className = 'vivered-sticky-atc__info';

    var titleEl = document.createElement('span');
    titleEl.className = 'vivered-sticky-atc__title';
    var titleSource = document.querySelector('.product__title');
    titleEl.textContent = titleSource ? titleSource.textContent.trim() : '';

    var priceEl = document.createElement('span');
    priceEl.className = 'vivered-sticky-atc__price';
    priceEl.textContent = formatPriceText();

    info.appendChild(titleEl);
    info.appendChild(priceEl);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vivered-sticky-atc__btn';
    btn.textContent = 'Į krepšelį';
    btn.addEventListener('click', function () {
      var currentRealBtn = document.querySelector('.product-form__cart-submit');
      if (currentRealBtn) {
        currentRealBtn.click();
      }
    });

    el.appendChild(info);
    el.appendChild(btn);
    document.body.appendChild(el);
    return el;
  }

  function refreshPrice() {
    if (!bar) return;
    var priceEl = bar.querySelector('.vivered-sticky-atc__price');
    if (priceEl) priceEl.textContent = formatPriceText();
  }

  function init() {
    if (!mqMobile.matches) return;
    var realBtn = document.querySelector('.product-form__cart-submit');
    if (!realBtn || bar) return;

    bar = buildBar(realBtn);

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        var backToTop = document.querySelector('.back-to-top');
        if (backToTop) {
          backToTop.classList.toggle('vivered-above-sticky-atc', scrolledPast);
        }
      });
    }, { threshold: 0 });
    observer.observe(realBtn);

    document.addEventListener('variant:changed', refreshPrice);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form')) {
        setTimeout(refreshPrice, 150);
      }
    });
  }

  function teardown() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (bar) {
      bar.parentNode.removeChild(bar);
      bar = null;
    }
    var backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
      backToTop.classList.remove('vivered-above-sticky-atc');
    }
  }

  function apply() {
    if (mqMobile.matches) {
      init();
    } else {
      teardown();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  if (mqMobile.addEventListener) {
    mqMobile.addEventListener('change', apply);
  } else if (mqMobile.addListener) {
    mqMobile.addListener(apply);
  }
})();

/* Vivered: MiMic produkto puslapis - apatines dubliuojancios rekomendaciju
   sekcijos ir sugadinto mokesciu/siuntimo teksto pasalinimas. Naudoja puslapio
   adresa (pathname), o ne CSS ID selektoriu, nes tas ID keiciasi kaskart
   dubliuojant tema. Taikoma visiems ekrano plociams. 2026-09-22 */
(function () {
  var MIMIC_PATH = '/products/mimic-mikroadateliu-pleistrai-gilioms-veido-raukslems';

  function apply() {
    if (location.pathname.indexOf(MIMIC_PATH) === -1) return;

    var rec = document.querySelector('.recommended-products');
    if (rec) {
      var wrap = rec.closest('[id^="shopify-section-"]') || rec;
      wrap.style.setProperty('display', 'none', 'important');
    }

    var policies = document.querySelector('.product__policies');
    if (policies) {
      policies.style.setProperty('display', 'none', 'important');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
